import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Alert as BsAlert, Button, Col, Modal, Row,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faPlus, faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { useSelector } from 'react-redux';
import ChannelSelector from '../../../alerts/AlertForms/ChannelSelector/ChannelSelector';
import RaaChannelKey from '../../../../classes/RaaChannelKey';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';

function AddAdditionalSensorModal({ show, onHide, onAdd }) {
  const [channelKey, setChannelKey] = useState(new RaaChannelKey());
  const [isDeviceSensor, setIsDeviceSensor] = useState(false);
  const { activeSubscriptionId } = useSelector(selectSessionInformation);

  const isSubmitDisabled = (
    channelKey.channelType === 0
    && channelKey.channelIndex === 0
  );

  const handleConfirm = () => {
    onAdd(channelKey);
    setChannelKey(new RaaChannelKey());
    setIsDeviceSensor(false);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Add Sensor
          <sup className="ml-1">
            <a
              className="text-primary"
              title="Add additional sensors to alert notifications."
              target="_blank"
              rel="noopener noreferrer"
              href="https://avtech.com/articles/11439/how-to-add-additional-sensor-readings-to-alert-notifications-in-your-roomalert-com-account"
            >
              <FontAwesomeIcon icon={faQuestionCircle} size="xs" />
            </a>
          </sup>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="justify-content-center">
          <Col lg={10} className="py-2">
            <ChannelSelector
              channelKey={channelKey}
              updateChannelKey={(ck) => {
                ck.subscriptionId = activeSubscriptionId;
                setChannelKey(ck);
              }}
              setIsDeviceSensor={setIsDeviceSensor}
              errorList={[]}
            />

            {isDeviceSensor && (
              <BsAlert variant="info" className="mt-4">
                <div className="d-flex">
                  <div className="mr-3">
                    <FontAwesomeIcon icon={faInfoCircle} size="lg" />
                  </div>
                  <div>
                    <p className="mb-2">
                      If you select
                      {' '}
                      <strong>Device</strong>
                      {' '}
                      from the
                      {' '}
                      <strong>Sensor</strong>
                      {' '}
                      drop-down menu,
                      you may choose these types of connections:
                    </p>
                    <ul className="pl-3 mb-0">
                      <li>
                        <strong>Link Connection: </strong>
                        Is your Room Alert device connected to Room Alert Link software?
                        {' '}
                        <a target="_blank" rel="noopener noreferrer" href="https://avtech.com/articles/16289/">
                          <em>For more info, click here.</em>
                        </a>
                      </li>
                      <li>
                        <strong>Push Status: </strong>
                        Is your Room Alert device pushing data to RoomAlert.com?
                        {' '}
                        <a target="_blank" rel="noopener noreferrer" href="https://avtech.com/articles/15801/">
                          <em>For more info, click here.</em>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </BsAlert>
            )}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleConfirm}
          disabled={isSubmitDisabled}
        >
          <FontAwesomeIcon icon={faPlus} className="mr-2" />
          Add Sensor
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

AddAdditionalSensorModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default AddAdditionalSensorModal;
